import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "../../../hooks/use-theme"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group-[.toaster]:shadow-xl group-[.toaster]:border group-[.toaster]:rounded-xl group-[.toaster]:px-4 group-[.toaster]:py-3",
          title: "group-[.toaster]:text-sm group-[.toaster]:font-semibold",
          description:
            "group-[.toaster]:text-xs group-[.toaster]:text-muted-foreground",
          actionButton:
            "group-[.toaster]:!bg-foreground group-[.toaster]:!text-background group-[.toaster]:!rounded-md group-[.toaster]:!text-xs group-[.toaster]:!font-semibold group-[.toaster]:!px-3 group-[.toaster]:!py-1.5 group-[.toaster]:!h-auto group-[.toaster]:hover:!opacity-90",
          cancelButton:
            "group-[.toaster]:!bg-muted group-[.toaster]:!text-muted-foreground group-[.toaster]:!rounded-md group-[.toaster]:!text-xs group-[.toaster]:!font-medium group-[.toaster]:!px-3 group-[.toaster]:!py-1.5 group-[.toaster]:!h-auto group-[.toaster]:hover:!bg-muted/80",
        },
      }}
      icons={{
        success: (
          <CircleCheckIcon className="size-5 text-[var(--success)]" />
        ),
        info: <InfoIcon className="size-5 text-[var(--info)]" />,
        warning: (
          <TriangleAlertIcon className="size-5 text-[var(--warning)]" />
        ),
        error: <OctagonXIcon className="size-5 text-[var(--error)]" />,
        loading: (
          <Loader2Icon className="size-5 animate-spin text-muted-foreground" />
        ),
      }}
      {...props}
    />
  )
}

export { Toaster }
